function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 125",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m 2.5188278,64.598897 32.9200052,32.92 a 8.06,8.06 0 1 0 11.4,-11.39 l -19.46,-19.43 h 64.72 a 8.06,8.06 0 0 0 0,-16.12 h -64.54 l 19.28,-19.31 a 8.06,8.06 0 0 0 -11.4,-11.39 l -32.9200052,32.92 a 8,8 0 0 0 -2.35998997,5.7 1.27,1.27 0 0 0 0,0.2 1.41,1.41 0 0 0 0,0.2 8.07,8.07 0 0 0 2.35998997,5.7 z",
    style: {
      fill: "#ffffff"
    },
    id: "path1"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowIcon);
export default __webpack_public_path__ + "static/media/arrow_icon.ee60deb0884ade9f2e10874fa9ac1224.svg";
export { ForwardRef as ReactComponent };